import { render, staticRenderFns } from "./PropertyAddUpdate.vue?vue&type=template&id=79ce2890&scoped=true"
import script from "./PropertyAddUpdate.vue?vue&type=script&lang=ts"
export * from "./PropertyAddUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ce2890",
  null
  
)

export default component.exports